import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IParams {
	animeId: string;
	episodeId: string;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean;
}

const LazyAnimeViewing = lazy(() => import(/* webpackChunkName: "AnimeViewing" */ "../anime-viewing/AnimeViewing"));

const AnimePage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, animeId, episodeId, path } = props;

	if (!loggedIn) {
		return <></>;
	}

	const animeIdNum = Number(animeId);
	const episodeIdNum = episodeId === "" ? undefined : Number(episodeId);
	if (isNaN(animeIdNum)) {
		return <AnimePage loggedIn={loggedIn} />;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyAnimeViewing animeId={animeIdNum} episodeId={episodeIdNum} />
	</ErrorBoundary>;
};

export default AnimePage;